import React, { useEffect, useRef, useState } from "react";

import {
  StyledHR,
  BlueTitle,
  ButtonGroupStart,
  ModalContainer,
  ModalContent,
  CloseButtonWrapper,
  ModalBody,
  ModalHeader,
  ModalFooter,
} from "../../shared/styles/global.styles";
import Button from "../Button/button";
import { IoCloseSharp } from "react-icons/io5";
import { Col, Row } from "react-bootstrap";
import { Label } from "../Label/styles";
import InputComponent from "../Input/input";
import Swal from "sweetalert2";
import FichaFinanceiraService from "../../services/FichaFinanceiraService";
import { GetFinancialRecordDto } from "../../shared/dtos/FichaFinanceira.dto";
import { FormaPagamentoDto } from "../../shared/dtos/FormaPagamento.dto";
import formaPagamentoService from "../../services/FormaPagamentoService";
import SelectComponent from "../Select/select";
import { MainContainer } from "./styles";
import caixaService from "../../services/CaixaService";

interface Props {
  show: boolean;
  onClose: () => void;
  installments: GetFinancialRecordDto[];
  onSuccess?: () => void;
}

const ManualClearanceModal: React.FC<Props> = ({
  show,
  onClose,
  installments,
  onSuccess,
}) => {
  const [totalValue, setTotalValue] = useState<number>();
  const [paidValue, setPaidValue] = useState<string>();
  const [adjustmentValue, setAdjustmentValue] = useState<string>();
  const [dateValue, setDateValue] = useState<string>("");
  const [selectedFormaPagamento, setSelectedFormaPagamento] =
    useState<FormaPagamentoDto>();
  const [invalidFields, setInvalidFields] = useState<string[]>([]);
  const [isRequest, setIsRequest] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [formaPagamento, setFormaPagamento] = useState<FormaPagamentoDto[]>([]);

  const inputRefs = useRef<{
    [key: string]: HTMLInputElement | HTMLSelectElement | null;
  }>({
    paidValue: null,
    dateValue: null,
    selectedFormaPagamento: null,
  });

  const resetFields = () => {
    setInvalidFields([]);
    setTotalValue(undefined);
    setPaidValue(undefined);
  };

  const handleClose = () => {
    resetFields();
    onClose();
  };

  const formatarValorEmReais = (valor: string) => {
    if (!valor) return "R$ 0,00";

    // Se o valor já estiver no formato numérico com ponto como separador decimal, converte diretamente para número
    const numero = parseFloat(valor.replace(",", "."));

    // Verifica se o valor é um número válido
    if (isNaN(numero)) return "R$ 0,00";

    // Formata o número para reais com separadores corretos
    return numero.toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
    });
  };

  // Função para formatar valores monetários
  const formatCurrency = (value: string) => {
    // Handle negative values
    const isNegative = value.startsWith("-");
    value = value.replace(/[^\d.]/g, ""); // Keep digits and decimal point

    // Remove non-numeric characters and handle decimal places
    value = value.replace(/\D/g, "");

    // Convert to number and format with 2 decimal places
    const numericValue = parseFloat(value) / 100;

    // Handle NaN case
    if (isNaN(numericValue)) {
      if (isNegative) {
        return "R$ -0,00";
      } else {
        return "R$ 0,00";
      }
    }

    value = numericValue.toFixed(2).replace(".", ",");

    // Add thousands separator and currency symbol, preserving negative sign
    return `R$ ${isNegative ? "-" : ""}${value.replace(
      /\B(?=(\d{3})+(?!\d))/g,
      "."
    )}`;
  };

  // Função para atualizar os valores dos campos
  const handleChangeValues = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    // Aplica formatação monetária para valores específicos
    let formattedValue = value;
    if (["paidValue"].includes(name)) {
      formattedValue = formatCurrency(value);
      setPaidValue(formattedValue);

      // Calcula o valor numérico a partir da string formatada em moeda
      const numericPaidValue = Number(
        formattedValue
          .replace(/[^\d-.,]/g, "")
          .replace(".", "")
          .replace(",", ".")
      );
      // Calcula a diferença entre o valor pago e o valor total
      const difference = numericPaidValue - totalValue!;
      // Formata a diferença para string em moeda, tratando possível NaN
      const adjustmentString = !isNaN(difference) ? difference.toString() : "0";
      const formatedValue = formatCurrency(Number(adjustmentString).toFixed(2));
      setAdjustmentValue(formatedValue);
    }

    if (["dateValue"].includes(name)) {
      setDateValue(formattedValue);
    }

    if (["adjustmentValue"].includes(name)) {
      // Check if value contains a negative sign
      const isNegative = value && value.includes("-");
      const cleanValue = value.replace(/[^\d]/g, "");

      const adjustmentString1 = !isNaN(Number(cleanValue))
        ? isNegative
          ? `-${cleanValue}`
          : cleanValue
        : isNegative
        ? "-0"
        : "0";

      formattedValue = formatCurrency(adjustmentString1);
      setAdjustmentValue(formattedValue);

      // Calcula o valor numérico a partir da string formatada em moeda
      const numericAdjutsmentValue = Number(
        formattedValue
          .replace(/[^\d-.,]/g, "")
          .replace(".", "")
          .replace(",", ".")
      );
      // Calcula a diferença entre o valor pago e o valor total
      const difference =
        numericAdjutsmentValue >= 0
          ? numericAdjutsmentValue + totalValue!
          : totalValue! + numericAdjutsmentValue;

      // Formata a diferença para string em moeda, tratando possível NaN
      const adjustmentString = !isNaN(difference) ? difference.toString() : "0";
      const formatedValue = formatCurrency(Number(adjustmentString).toFixed(2));
      setPaidValue(formatedValue);
    }
  };

  // const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  //   let value = e.target.value.replace(/[^\d,]/g, ''); // Remove caracteres não numéricos
  //   let numericValue = value.replace(',', '.'); // Troca vírgula por ponto
  //   let number = parseFloat(numericValue); // Converte para número

  //   if (value === '' || isNaN(number)) {
  //     setPaidValue(0);
  //     setInvalidFields((prev) =>
  //       prev.includes('paidValue') ? prev : [...prev, 'paidValue']
  //     );
  //   } else if (number > 0) {
  //     setPaidValue(parseFloat(formatarValorEmReais(value).replace(/[R$ \.]/g, '')));
  //     setInvalidFields((prev) => prev.filter((field) => field !== 'paidValue'));
  //   } else {
  //     setInvalidFields((prev) =>
  //       prev.includes('paidValue') ? prev : [...prev, 'paidValue']
  //     );
  //   }

  //   clearError(e);
  // };

  const clearError = async (
    event:
      | React.ChangeEvent<HTMLInputElement>
      | React.ChangeEvent<HTMLSelectElement>
  ) => {
    const { name } = event.target;

    setInvalidFields((prev) => prev.filter((field) => field !== name));
  };

  const calculateTotalValue = () => {
    // Prepara os dados das parcelas
    const installmentData = installments.map((installment) => ({
      id: installment.id,
      installmentValue: Number(
        installment.valorParcela.replace(/[^\d.,]/g, "").replace(",", ".")
      ),
    }));
    // Calcula o valor total
    const calculatedTotalValue = installmentData.reduce(
      (sum, item) => sum + item.installmentValue,
      0
    );
    setTotalValue(calculatedTotalValue);
  };

  const handleSubmit = async () => {
    try {
      let invalidInputs: boolean = false;
      if (
        !paidValue ||
        parseFloat(paidValue.replace(/[^\d.,]/g, "").replace(",", ".")) <= 0
      ) {
        setInvalidFields((prev) =>
          prev.includes("paidValue") ? prev : [...prev, "paidValue"]
        );
        invalidInputs = true;
      }
      if (!dateValue) {
        setInvalidFields((prev) =>
          prev.includes("dateValue") ? prev : [...prev, "dateValue"]
        );
        invalidInputs = true;
      }

      if (!selectedFormaPagamento) {
        setInvalidFields((prev) =>
          prev.includes("formaPagamento") ? prev : [...prev, "formaPagamento"]
        );
        invalidInputs = true;
      }

      if (invalidInputs) {
        Swal.fire({
          title: "Campos Inválidos",
          text: "Por favor, corrija os campos inválidos.",
          icon: "warning",
          confirmButtonText: "OK",
          allowOutsideClick: false,
        });
        return;
      }

      // Mostra loading
      Swal.fire({
        title: "Processando",
        text: "Realizando baixa manual...",
        icon: "info",
        allowOutsideClick: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      // Prepara os dados das parcelas
      const installmentData = installments.map((installment) => ({
        id: installment.id,
        installmentValue: Number(
          installment.valorParcela.replace(/[^\d.,]/g, "").replace(",", ".")
        ),
      }));

      // Calcula o valor total
      const calculatedTotalValue = installmentData.reduce(
        (sum, item) => sum + item.installmentValue,
        0
      );

      // Formata os valores para 2 casas decimais
      const formattedPaidValue = Number(
        paidValue!.replace(/[^\d,]/g, "").replace(",", ".")
      );
      const formattedTotalValue = Number(calculatedTotalValue.toFixed(2));

      const response = await FichaFinanceiraService.manualClearance(
        installmentData,
        formattedPaidValue,
        dateValue,
        selectedFormaPagamento!, // Certifique-se de que selectedFormaPagamento não seja undefined
        formattedTotalValue
      );

      if (response?.status === true) {
        Swal.close();
        Swal.fire({
          icon: "success",
          title: "Sucesso",
          text: "Baixa manual realizada com sucesso!",
          confirmButtonText: "OK",
          allowOutsideClick: false,
        }).then(() => {
          if (onSuccess) {
            onSuccess();
          }
          handleClose();
        });
      } else {
        throw new Error(
          response?.message || "Erro ao processar a resposta do servidor"
        );
      }
    } catch (error: any) {
      console.error("Erro completo:", error);
      Swal.close();

      // Tenta extrair a mensagem mais específica do erro
      const errorMessage =
        error.response?.data?.message ||
        error.response?.data?.error ||
        error.message ||
        "Ocorreu um erro ao realizar a baixa manual";

      Swal.fire({
        icon: "error",
        title: "Erro",
        text: errorMessage,
        confirmButtonText: "OK",
        allowOutsideClick: false,
      });
    }
  };

  const getFormaPagamento = async () => {
    try {
      await formaPagamentoService.getAllFormaPagamento().then((response) => {
        if (response.length > 0) {
          setFormaPagamento(response);
        }
      });
    } catch (error) {
      console.error("Erro ao buscar formas de pagamento:", error);
      Swal.fire({
        icon: "error",
        title: "Erro",
        text: "Ocorreu um erro ao buscar formas de pagamento.",
        confirmButtonText: "OK",
        allowOutsideClick: false,
      });
    }
  };

  useEffect(() => {
    if (installments.length > 0) {
      // Limpa os valores e remove caracteres não numéricos
      const soma = installments.reduce((acc, curr) => {
        const valor = Number(
          curr.valorParcela.replace(/[^\d.,]/g, "").replace(",", ".")
        );
        return acc + valor;
      }, 0);

      setTotalValue(soma);
      setPaidValue(formatarValorEmReais(soma.toString())); // Inicializa o valor pago com o total
    }
  }, [installments]);

  useEffect(() => {
    if (show) {
      getFormaPagamento();
      calculateTotalValue();
    }
  }, [show]);

  return (
    <ModalContainer show={show}>
      <ModalContent width={35}>
        <Button
          type="button"
          schemaButton="x-close"
          action={() => handleClose()}
          icon={<IoCloseSharp size={30} />}
          position="absolute"
          top={10}
          right={10}
        />

        <ModalHeader>
          <BlueTitle>Baixa Manual</BlueTitle>
        </ModalHeader>
        <ModalBody>
          <Col>
            <Label>
              Valor Total:{" "}
              {totalValue ? formatarValorEmReais(totalValue.toString()) : ""}
            </Label>
          </Col>
          <Row>
          <Col>
            <Label>Valor a pagar</Label>
            <InputComponent
              name="paidValue"
              id="paidValue"
              ref={(el) => (inputRefs.current["paidValue"] = el)}
              value={paidValue || ""}
              onChange={(e) => {
                handleChangeValues(e);
                clearError(e);
              }}
              placeholder="R$ 0,00"
              disabled={isRequest}
              color="black"
              width={Number("100%")}
              errorMessage={
                invalidFields.includes("paidValue")
                  ? "Preencha o campo valor pago"
                  : ""
              }
            />
          </Col>
          <Col>
            <Label>Valor de ajuste</Label>
            <InputComponent
              name="adjustmentValue"
              id="adjustmentValue"
              ref={(el) => (inputRefs.current["adjustmentValue"] = el)}
              value={adjustmentValue || ""}
              onChange={(e) => {
                handleChangeValues(e);
                clearError(e);
              }}
              placeholder="R$ 0,00"
              disabled={isRequest}
              color="black"
              width={Number("100%")}
              errorMessage={
                invalidFields.includes("adjustmentValue")
                  ? "Preencha o campo de ajuste do valor pago"
                  : ""
              }
            />
          </Col>
          </Row>
          <Row>
          <Col>
            <Label>Data de pagamento</Label>
            <InputComponent
              type="date"
              name="dateValue"
              id="dateValue"
              ref={(el) => (inputRefs.current["dateValue"] = el)}
              value={dateValue}
              onChange={(e) => {
                handleChangeValues(e);
                clearError(e);
              }}
              placeholder="Selecione a data de pagamento"
              disabled={isRequest}
              color="black"
              width={Number("100%")}
              errorMessage={
                invalidFields.includes("dateValue")
                  ? "Preencha o campo data de pagamento"
                  : ""
              }
            />
          </Col>
          <Col>
            <Label>Forma de Pagamento</Label>
            <SelectComponent
              ref={(el) => (inputRefs.current["selectedFormaPagamento"] = el)}
              color="black"
              placeholder="Selecione"
              id="formaPagamento"
              width={Number("100%")}
              name="formaPagamento"
              value={selectedFormaPagamento?.id?.toString() || ""}
              onChange={(e) => {
                setSelectedFormaPagamento(
                  formaPagamento.find(
                    (formaPagamento) =>
                      formaPagamento.id!.toString() === e.target.value
                  )
                );
                clearError(e);
              }}
              options={formaPagamento.map((formaPagamento) => ({
                value: formaPagamento.id!.toString(),
                label: formaPagamento.nome,
              }))}
              errorMessage={
                invalidFields.includes("formaPagamento")
                  ? "A seleção da forma de pagamento é obrigatória"
                  : ""
              }
            />
          </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button
            schemaButton="full-primary"
            action={handleSubmit}
            disabled={isRequest || invalidFields.length > 0}
          >
            Confirmar
          </Button>
        </ModalFooter>
      </ModalContent>
    </ModalContainer>
  );
};

export default ManualClearanceModal;
